import { FC } from 'react';

import { defectIsBinnenPeriodeNietInzetbaar } from '@/domain/defecten/defect';
import { Conflict } from '@/types/Conflicten';
import usePlankTableStore from '@/views/ddp/hooks/usePlankTableStore';
import { isHardVerkeerdMat } from '@/views/ddp/utils/conflict';

import DefectIcon from '../../defect/DefectIcon';

import styles from '../Conflict.module.css';

const VerkeerdMatAssigned: FC<{ conflict: Conflict; showRelatedDefect?: boolean; showDefectIcon?: boolean }> = ({
  conflict,
  showRelatedDefect = false,
  showDefectIcon = false,
}) => {
  const relatedDefect = usePlankTableStore((state) => state.getRelatedDefect(String(conflict.eenheidNummer)));
  const laatsteElement = conflict.elementen.at(-1);
  const toontLabel = !(conflict.elementen.length === 0 && conflict.lastAcceptedPerDay);
  const label = toontLabel ? `${laatsteElement?.materieelSoort}-${laatsteElement?.materieelAanduiding}` : undefined;
  // Houdt minimaal 'S…-<aanduiding>' zichtbaar, ook als de rij krap is.
  const labelMinWidthStyle = laatsteElement?.materieelAanduiding
    ? { minWidth: `calc(${String(laatsteElement.materieelAanduiding).length + 2}ch + 4px)` }
    : { minWidth: 0 };
  return (
    <>
      {['VERKEERD_MATERIEEL', 'VERSTERKT_MATERIEEL'].includes(conflict.type) && (
        <>
          {relatedDefect && showRelatedDefect && showDefectIcon && (
            <DefectIcon
              defectSoort={relatedDefect.soort}
              nietInzetbaarBinnen24Uur={defectIsBinnenPeriodeNietInzetbaar(relatedDefect)}
            />
          )}
          <div
            style={{ display: 'inline-flex', gap: '4px', ...labelMinWidthStyle }}
            className={isHardVerkeerdMat(conflict) ? styles.verkeerdMatStyleHard : styles.verkeerdMatStyleZacht}
          >
            {conflict.elementen.length === 0 && conflict.lastAcceptedPerDay ? (
              <>
                {conflict?.lastAcceptedPerDay?.map((el) => (
                  <span key={el.treinNummer} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    {el.materieelSoort}-{el.materieelAanduiding}
                  </span>
                ))}
              </>
            ) : (
              <span className={styles.verkeerdMatLabelStyle} title={label} aria-label={label}>
                <span aria-hidden className={styles.verkeerdMatLabelStartStyle}>
                  {laatsteElement?.materieelSoort}-
                </span>
                <span aria-hidden className={styles.verkeerdMatLabelEndStyle}>
                  {laatsteElement?.materieelAanduiding}
                </span>
              </span>
            )}
          </div>
        </>
      )}
    </>
  );
};
export default VerkeerdMatAssigned;
